import React from "react";
import TextElement from "./preview-element/TextElement";
import moment from "moment";
import { MdCheck, MdOutlineClose } from "react-icons/md";
import { DurationDisplayText } from "./DurationDisplay";

export default function PrsDataPreview({ classes, selectedItem }) {
  return (
    <>
      <TextElement
        label="Track Title"
        classes={classes}
        data={selectedItem?.prsTrack?.trackTitle}
      />
      <TextElement
        label="Artists"
        classes={classes}
        data={selectedItem?.prsTrack?.performer && Array.isArray(selectedItem?.prsTrack?.performer) ? selectedItem?.prsTrack?.performer?.join(', ').replace(/&amp;/gi, "&") : selectedItem?.prsTrack?.performer}
      />
       <TextElement
        label="Last Update"
        classes={classes}
        data={selectedItem?.prsSearchDateTime ? moment(selectedItem?.prsSearchDateTime).format("DD/MM/YYYY h:mm:ss A") : null}
      />
      <TextElement
        label="Composers"
        classes={classes}
        data={selectedItem?.prsTrack?.composer && Array.isArray(selectedItem?.prsTrack?.composer) ? selectedItem?.prsTrack?.composer?.join(', ').replace(/&amp;/gi, "&") : selectedItem?.prsTrack?.composer}
      />
      <TextElement
        label="Publishers"
        classes={classes}
        data={selectedItem?.prsTrack?.publisher && Array.isArray(selectedItem?.prsTrack?.publisher) ? selectedItem?.prsTrack?.publisher?.join(', ').replace(/&amp;/gi, "&") : selectedItem?.prsTrack?.publisher}
      />
      <TextElement
        label="Record Labels"
        classes={classes}
        data={selectedItem?.prsTrack?.recordLabel && Array.isArray(selectedItem?.prsTrack?.recordLabel) ? selectedItem?.prsTrack?.recordLabel?.join(', ').replace(/&amp;/gi, "&") : selectedItem?.prsTrack?.recordLabel}
      />
      <TextElement
        label="Music Origin"
        classes={classes}
        data={selectedItem?.prsTrack?.musicOrigin}
      />
      <TextElement
        label="Tune Code"
        classes={classes}
        data={selectedItem?.prsTrack?.prs}
      />
      <TextElement
        label="Album Title"
        classes={classes}
        data={selectedItem?.prsTrack?.prodName}
      />
      <TextElement
        label="Cat No"
        classes={classes}
        data={selectedItem?.prsTrack?.catNo}
      />
      <TextElement
        label="Position"
        classes={classes}
        data={selectedItem?.prsTrack?.position}
      />
      <TextElement
        label="ISRC"
        classes={classes}
        data={selectedItem?.prsTrack?.isrc}
      />
      <TextElement
        label="Duration"
        classes={classes}
        data={selectedItem?.prsTrack?.duration ? DurationDisplayText({ seconds: selectedItem?.prsTrack?.duration }) : null}
      />

      <TextElement
        label="Mechanical Right"
        classes={classes}
        showCustomTitle={true}
        customTitle={""}
        data={selectedItem?.prsTrack?.ownersMech ? <>
          {selectedItem?.prsTrack?.ownersMech.map(d => {
            return <div className={classes.rightName} title={d.name} >{d.name} <span className={d.isPrs ? classes.rightStatusGreen : classes.rightStatusRed}>{d.isPrs ? <MdCheck class="yesGreen" /> : <MdOutlineClose class="noRed" />}</span></div>
          })}
        </> : null}
      />
      {/* <TextElement
        label="Compilation"
        classes={classes}
        data={selectedItem?.prsTrack?.compilation}
      /> */}
      <TextElement
        label="PRS Restricted"
        classes={classes}
        data={(selectedItem?.prsTrack?.prsRestricted || selectedItem?.prsTrack?.prsRestricted === true ? "True" : "False")}
      />
      <TextElement
        label="Algorithm"
        classes={classes}
        data={selectedItem?.prsTrack?.algorithm}
      />
      {/* <TextElement
          label="Percentage"
          classes={classes}
          data={selectedItem?.prsTrack?.prsmatchPercentages ? JSON.stringify(selectedItem?.prsTrack?.prsmatchPercentages): null }
        /> */}
    </>

  )
}
